/** Mapeamento de extensão de arquivo para a linguagem usada no editor. */
export type LanguageId =
  | "javascript"
  | "jsx"
  | "typescript"
  | "tsx"
  | "python"
  | "java"
  | "kotlin"
  | "go"
  | "rust"
  | "php"
  | "c"
  | "cpp"
  | "csharp"
  | "ruby"
  | "swift"
  | "sql"
  | "json"
  | "markdown"
  | "css"
  | "html"
  | "xml"
  | "shell"
  | "yaml"
  | "toml"
  | "dockerfile"
  | "plaintext";

const BY_EXTENSION: Record<string, LanguageId> = {
  js: "javascript",
  mjs: "javascript",
  cjs: "javascript",
  jsx: "jsx",
  ts: "typescript",
  mts: "typescript",
  cts: "typescript",
  tsx: "tsx",
  py: "python",
  java: "java",
  kt: "kotlin",
  kts: "kotlin",
  go: "go",
  rs: "rust",
  php: "php",
  c: "c",
  h: "c",
  cpp: "cpp",
  cc: "cpp",
  cxx: "cpp",
  hpp: "cpp",
  hh: "cpp",
  cs: "csharp",
  rb: "ruby",
  swift: "swift",
  sql: "sql",
  json: "json",
  md: "markdown",
  markdown: "markdown",
  css: "css",
  html: "html",
  htm: "html",
  xml: "xml",
  svg: "xml",
  sh: "shell",
  bash: "shell",
  zsh: "shell",
  yml: "yaml",
  yaml: "yaml",
  toml: "toml",
  dockerfile: "dockerfile",
};

/** Arquivos reconhecidos pelo nome (sem extensão ou com nome fixo). */
const BY_NAME: Record<string, LanguageId> = {
  Dockerfile: "dockerfile",
  Containerfile: "dockerfile",
  Makefile: "plaintext",
  Gemfile: "ruby",
  Rakefile: "ruby",
  ".bashrc": "shell",
  ".zshrc": "shell",
  ".env": "shell",
};

export const LANGUAGE_LABELS: Record<LanguageId, string> = {
  javascript: "JavaScript",
  jsx: "JavaScript JSX",
  typescript: "TypeScript",
  tsx: "TypeScript JSX",
  python: "Python",
  java: "Java",
  kotlin: "Kotlin",
  go: "Go",
  rust: "Rust",
  php: "PHP",
  c: "C",
  cpp: "C++",
  csharp: "C#",
  ruby: "Ruby",
  swift: "Swift",
  sql: "SQL",
  json: "JSON",
  markdown: "Markdown",
  css: "CSS",
  html: "HTML",
  xml: "XML",
  shell: "Shell",
  yaml: "YAML",
  toml: "TOML",
  dockerfile: "Dockerfile",
  plaintext: "Texto",
};

export function languageForPath(path: string): LanguageId {
  const name = path.split("/").pop() ?? path;
  const byName = BY_NAME[name];
  if (byName) return byName;
  // Dockerfile.dev, Dockerfile.prod…
  if (/^(Docker|Container)file\./.test(name)) return "dockerfile";
  if (name.startsWith(".env.")) return "shell";
  const dot = name.lastIndexOf(".");
  if (dot < 0) return "plaintext";
  return BY_EXTENSION[name.slice(dot + 1).toLowerCase()] ?? "plaintext";
}
